import type { Language } from '../../i18n';
import { useTranslation } from '../../hooks/useTranslation';
import { useTelegramTheme, getInputClasses } from '../../hooks/useTelegramTheme';

interface EnterUIDProps {
  exchange: string;
  uid: string;
  onUIDChange: (uid: string) => void;
  language: Language;
  hasEmail?: boolean;
  onNavigateToSettings?: () => void;
}

const EnterUID = ({ exchange, uid, onUIDChange, hasEmail = true, onNavigateToSettings }: EnterUIDProps) => {
  const { t } = useTranslation();
  const theme = useTelegramTheme();
  const exchangeName = exchange.toUpperCase();

  return (
    <div>
      <h2 className="text-xl font-bold text-white mb-2">
        {`${exchangeName} UID`}
      </h2>
      
      {!hasEmail && (
        <div className="bg-yellow-500/20 border border-yellow-500/50 rounded-xl p-4 mb-4">
          <div className="flex items-start gap-3">
            <svg className="w-5 h-5 text-yellow-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            <div className="flex-1">
              <p className="text-sm text-yellow-200 mb-2">
                {t('settings.emailVerification')}
              </p>
              {onNavigateToSettings && (
                <button
                  onClick={onNavigateToSettings}
                  className="text-sm font-semibold text-yellow-300 hover:text-yellow-200 underline flex items-center gap-1"
                >
                  {t('nav.settings')}
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              )}
            </div>
          </div>
        </div>
      )}
      
      <div className="bg-tg-secondary rounded-xl p-4 mb-6">
        <div className="text-sm text-tg-hint mb-4">
          UID
          <button className="text-primary ml-1 font-semibold flex items-center gap-1 inline-flex">
            {t('linkExchange.enterUID')}
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
          </button>
        </div>
        <input
          type="text"
          value={uid}
          onChange={(e) => onUIDChange(e.target.value)}
          placeholder={`${exchangeName} UID`}
          className={getInputClasses(theme)}
          disabled={!hasEmail}
        />
      </div>
    </div>
  );
};

export default EnterUID;


